<template>
  <div class="almacen-page">
    <!-- ============ HEADER ============ -->
    <div class="alm-header">
      <div>
        <span class="header-eyebrow">Taller</span>
        <h2 class="header-title">Máquinas</h2>
      </div>
      <div class="header-actions">
        <button class="btn-alm btn-alm--soft" @click="abrirCategorias"><i class="fa-solid fa-tags"></i> Categorías</button>
        <button class="btn-alm btn-alm--primary" @click="abrirMaquinaForm(null)"><i class="fa-solid fa-plus"></i> Nueva máquina</button>
      </div>
    </div>

    <!-- ============ KPI GENERAL ============ -->
    <div class="kpi-strip">
      <div class="kpi-card">
        <span class="kpi-label">Máquinas</span>
        <span class="kpi-value">{{ kpi.numMaquinas || 0 }}</span>
        <span class="kpi-foot">activas</span>
      </div>
      <div class="kpi-card">
        <span class="kpi-label">Averías</span>
        <span class="kpi-value">{{ kpi.totalAverias || 0 }}</span>
        <span class="kpi-foot">totales</span>
      </div>
      <div class="kpi-card">
        <span class="kpi-label">Gasto</span>
        <span class="kpi-value">{{ fmtMoney(kpi.gastoTotal) }}</span>
        <span class="kpi-foot">acumulado</span>
      </div>
      <div class="kpi-card">
        <span class="kpi-label">Mecánico</span>
        <span class="kpi-value">{{ kpi.diasEntreAverias != null ? kpi.diasEntreAverias : '—' }}</span>
        <span class="kpi-foot">días entre averías</span>
      </div>
    </div>

    <!-- ============ BARRA DE CATEGORÍAS ============ -->
    <div class="cat-bar">
      <button class="cat-chip" :class="{ 'cat-chip--active': !filtroCategoria }" @click="seleccionarCategoria(null)">
        Todas <small>{{ listMaquinas.length }}</small>
      </button>
      <button
        v-for="c in listCategorias"
        :key="c.id"
        class="cat-chip"
        :class="{ 'cat-chip--active': filtroCategoria && filtroCategoria.id == c.id }"
        @click="seleccionarCategoria(c)"
      >
        {{ c.nombre }} <small>{{ c.numMaquinas }}</small>
      </button>
      <button class="cat-chip cat-chip--add" @click="abrirCategorias"><i class="fa-solid fa-plus"></i></button>
    </div>

    <!-- ============ VISTA DE CATEGORÍA ============ -->
    <div class="maq-detalle" v-if="filtroCategoria && !maquinaSel">
      <div class="maq-detalle__head">
        <div>
          <h3><i class="fa-solid fa-tag cat-ico"></i> {{ filtroCategoria.nombre }}</h3>
          <span class="maq-muted">Desglose de averías de la categoría</span>
        </div>
      </div>

      <div class="maq-stats">
        <div class="stat-box">
          <span class="stat-box__num">{{ catStats.totalAverias || 0 }}</span>
          <span class="stat-box__lbl">Averías</span>
        </div>
        <div class="stat-box">
          <span class="stat-box__num">{{ fmtMoney(catStats.gastoTotal) }}</span>
          <span class="stat-box__lbl">Gasto total</span>
        </div>
        <div class="stat-box">
          <span class="stat-box__num">{{ catStats.diasEntreAverias != null ? catStats.diasEntreAverias + ' días' : '—' }}</span>
          <span class="stat-box__lbl">Cada cuánto viene el mecánico</span>
        </div>
      </div>

      <div class="maq-cols">
        <div class="maq-panel">
          <div class="maq-panel__head"><span>Averías más comunes</span></div>
          <div class="comun-list" v-if="catStats.comunes && catStats.comunes.length">
            <div class="comun-row" v-for="(c, i) in catStats.comunes" :key="i">
              <span class="comun-row__txt">{{ c.motivo }}</span>
              <span class="comun-row__veces">{{ c.veces }}×</span>
              <span class="comun-row__gasto">{{ fmtMoney(c.gasto) }}</span>
            </div>
          </div>
          <span class="maq-muted maq-pad" v-else>Sin averías en esta categoría.</span>
        </div>

        <div class="maq-panel">
          <div class="maq-panel__head"><span>Desglose por máquina</span></div>
          <div class="comun-list" v-if="catStats.porMaquina && catStats.porMaquina.length">
            <div class="comun-row comun-row--click" v-for="mq in catStats.porMaquina" :key="mq.id" @click="seleccionarPorId(mq.id)">
              <span class="comun-row__txt">{{ mq.nombre }}</span>
              <span class="comun-row__veces">{{ mq.numAverias }}</span>
              <span class="comun-row__gasto">{{ fmtMoney(mq.gasto) }}</span>
            </div>
          </div>
          <span class="maq-muted maq-pad" v-else>No hay máquinas en esta categoría.</span>
        </div>
      </div>
    </div>

    <!-- ============ TABLA DE MÁQUINAS ============ -->
    <div class="list-card" v-show="!maquinaSel">
      <div class="list-card__header">
        <div class="search-box">
          <i class="fa-solid fa-magnifying-glass search-box__icon"></i>
          <input class="search-box__input" placeholder="Buscar máquina..." v-model="buscarMaquina" />
        </div>
        <span class="list-card__hint">{{ maquinasFiltradas.length }} máquinas</span>
      </div>
      <b-table
        :items="maquinasFiltradas"
        :fields="columnasMaquinas"
        thead-class="table-head"
        tbody-tr-class="table-row maq-row"
        responsive
        hover
        show-empty
        @row-clicked="seleccionar"
      >
        <template #empty>
          <div class="maq-empty maq-empty--sm"><i class="fa-solid fa-gears"></i><span>No hay máquinas</span></div>
        </template>
        <template #cell(refInterna)="data">
          <span class="cell-mono" v-if="data.item.refInterna">{{ data.item.refInterna }}</span>
          <span class="maq-muted" v-else>—</span>
        </template>
        <template #cell(nombre)="data">
          <div class="cell-nombre">
            <span class="cell-nombre__name">{{ data.item.nombre }}</span>
            <span class="cell-nombre__sub" v-if="data.item.nota">{{ data.item.nota }}</span>
          </div>
        </template>
        <template #cell(categoria)="data">
          <span class="cat-badge" v-if="data.item.categoria">{{ data.item.categoria }}</span>
          <span class="maq-muted" v-else>—</span>
        </template>
        <template #cell(numAverias)="data"><span class="cell-mono">{{ data.item.numAverias }}</span></template>
        <template #cell(gastoTotal)="data"><span class="cell-mono">{{ fmtMoney(data.item.gastoTotal) }}</span></template>
        <template #cell(ultimaAveria)="data">
          <span class="cell-mono" v-if="data.item.ultimaAveria">{{ fechaCorta(data.item.ultimaAveria) }}</span>
          <span class="maq-muted" v-else>Sin averías</span>
        </template>
        <template #cell(acciones)="data">
          <div class="maq-acciones" @click.stop>
            <button class="icon-btn" @click="abrirMaquinaForm(data.item)"><i class="fa-solid fa-pen"></i></button>
            <button class="icon-btn icon-btn--danger" @click="eliminarMaquina(data.item)"><i class="fa-solid fa-trash"></i></button>
          </div>
        </template>
      </b-table>
    </div>

    <!-- ============ DETALLE DE LA MÁQUINA ============ -->
    <div class="maq-detalle" v-if="maquinaSel">
      <div class="maq-detalle__head">
        <div>
          <h3>{{ maquinaSel.nombre }}</h3>
          <span class="maq-detalle__meta">
            <span class="cat-badge" v-if="maquinaSel.categoria">{{ maquinaSel.categoria }}</span>
            <span class="maq-muted" v-if="maquinaSel.refFabricante">Ref. fabricante: {{ maquinaSel.refFabricante }}</span>
            <span class="maq-muted" v-if="maquinaSel.refInterna">Ref. interna: {{ maquinaSel.refInterna }}</span>
            <span class="maq-muted" v-if="maquinaSel.nota">{{ maquinaSel.nota }}</span>
          </span>
        </div>
        <div class="maq-detalle__actions">
          <button class="btn-alm btn-alm--soft" @click="cerrarDetalle"><i class="fa-solid fa-arrow-left"></i> Volver</button>
          <button class="btn-alm btn-alm--soft" @click="abrirMaquinaForm(maquinaSel)"><i class="fa-solid fa-pen"></i> Editar</button>
          <button class="btn-alm btn-alm--danger-soft" @click="eliminarMaquina(maquinaSel)"><i class="fa-solid fa-trash"></i></button>
        </div>
      </div>

      <div class="maq-stats">
        <div class="stat-box">
          <span class="stat-box__num">{{ stats.totalAverias || 0 }}</span>
          <span class="stat-box__lbl">Averías</span>
        </div>
        <div class="stat-box">
          <span class="stat-box__num">{{ fmtMoney(stats.gastoTotal) }}</span>
          <span class="stat-box__lbl">Gasto total</span>
        </div>
        <div class="stat-box">
          <span class="stat-box__num">{{ stats.diasEntreAverias != null ? stats.diasEntreAverias + ' días' : '—' }}</span>
          <span class="stat-box__lbl">Cada cuánto viene el mecánico</span>
        </div>
      </div>

      <div class="maq-cols">
        <div class="maq-panel">
          <div class="maq-panel__head"><span>Averías más comunes</span></div>
          <div class="comun-list" v-if="stats.comunes && stats.comunes.length">
            <div class="comun-row" v-for="(c, i) in stats.comunes" :key="i">
              <span class="comun-row__txt">{{ c.motivo }}</span>
              <span class="comun-row__veces">{{ c.veces }}×</span>
              <span class="comun-row__gasto">{{ fmtMoney(c.gasto) }}</span>
            </div>
          </div>
          <span class="maq-muted maq-pad" v-else>Todavía no hay averías registradas.</span>
        </div>

        <div class="maq-panel">
          <div class="maq-panel__head">
            <span>Motivos de esta máquina</span>
            <button class="btn-alm btn-alm--soft btn-alm--xs" @click="abrirCopiarMotivos"><i class="fa-solid fa-copy"></i> Copiar de otra</button>
          </div>
          <div class="motivo-chips">
            <span class="motivo-chip" v-for="mo in motivos" :key="mo.id">
              {{ mo.texto }}
              <small v-if="mo.precio != null">· {{ fmtMoney(mo.precio) }}</small>
              <i class="fa-solid fa-xmark motivo-chip__del" @click="eliminarMotivo(mo)"></i>
            </span>
            <span class="maq-muted" v-if="motivos.length == 0">Sin motivos. Añade abajo o copia de otra máquina.</span>
          </div>
          <div class="motivo-add">
            <b-form-input v-model="nuevoMotivo.texto" placeholder="Nuevo motivo" class="maq-input" @keyup.enter="crearMotivo" />
            <b-form-input v-model.number="nuevoMotivo.precio" type="number" step="any" placeholder="€ opc." class="maq-input maq-input--sm" @keyup.enter="crearMotivo" />
            <button class="btn-alm btn-alm--primary btn-alm--xs" @click="crearMotivo"><i class="fa-solid fa-plus"></i></button>
          </div>
        </div>
      </div>

      <div class="maq-panel">
        <div class="maq-panel__head">
          <span>Registro de averías</span>
          <button class="btn-alm btn-alm--primary btn-alm--xs" @click="abrirAveriaForm"><i class="fa-solid fa-plus"></i> Registrar avería</button>
        </div>
        <b-table
          :items="averias"
          :fields="columnasAverias"
          thead-class="table-head"
          tbody-tr-class="table-row"
          responsive
          show-empty
        >
          <template #empty>
            <div class="maq-empty maq-empty--sm"><i class="fa-solid fa-clipboard-list"></i><span>Sin averías registradas</span></div>
          </template>
          <template #cell(fecha)="data"><span class="cell-mono">{{ fechaCorta(data.item.fecha) }}</span></template>
          <template #cell(motivo)="data"><span>{{ data.item.motivo }}</span></template>
          <template #cell(estado)="data">
            <button
              v-if="!data.item.reparada"
              class="estado-badge estado-badge--pendiente"
              title="Marcar como reparada"
              @click="marcarReparada(data.item, true)"
            >
              <i class="fa-solid fa-wrench"></i> Pendiente
            </button>
            <button
              v-else
              class="estado-badge estado-badge--reparada"
              title="Volver a pendiente"
              @click="marcarReparada(data.item, false)"
            >
              <i class="fa-solid fa-check"></i> Reparada
              <span class="estado-badge__fecha" v-if="data.item.fechaReparada">{{ fechaCorta(data.item.fechaReparada) }}</span>
            </button>
          </template>
          <template #cell(precio)="data">
            <span class="cell-mono" v-if="data.item.precio != null">{{ fmtMoney(data.item.precio) }}</span>
            <span class="maq-muted" v-else>—</span>
          </template>
          <template #cell(nota)="data"><span class="maq-muted">{{ data.item.nota || '—' }}</span></template>
          <template #cell(usuario)="data"><span>{{ data.item.usuario || '—' }}</span></template>
          <template #cell(acciones)="data">
            <div class="maq-acciones">
              <button class="icon-btn" @click="abrirAveriaForm(data.item)"><i class="fa-solid fa-pen"></i></button>
              <button class="icon-btn icon-btn--danger" @click="eliminarAveria(data.item)"><i class="fa-solid fa-trash"></i></button>
            </div>
          </template>
        </b-table>
      </div>
    </div>

    <!-- ============ MODAL MÁQUINA ============ -->
    <b-modal v-model="showMaquinaModal" :title="maquinaForm.id ? 'Editar máquina' : 'Nueva máquina'" @ok.prevent="guardarMaquina" ok-title="Guardar" cancel-title="Cancelar">
      <div class="maq-fields">
        <div class="maq-field">
          <label>Nombre</label>
          <b-form-input v-model="maquinaForm.nombre" placeholder="Ej: Cortadora láser" class="maq-input" />
        </div>
        <div class="maq-field">
          <label>Categoría</label>
          <v-select v-model="maquinaForm.categoriaSel" label="nombre" :options="listCategorias" class="select-styled" placeholder="Sin categoría" />
        </div>
        <div class="maq-field">
          <label>Referencia Fabricante</label>
          <b-form-input v-model="maquinaForm.refFabricante" placeholder="Opcional" class="maq-input" />
        </div>
        <div class="maq-field">
          <label>Referencia Interna</label>
          <b-form-input v-model="maquinaForm.refInterna" placeholder="Opcional" class="maq-input" />
        </div>
        <div class="maq-field">
          <label>Nota</label>
          <b-form-input v-model="maquinaForm.nota" placeholder="Opcional" class="maq-input" />
        </div>
      </div>
    </b-modal>

    <!-- ============ MODAL AVERÍA ============ -->
    <b-modal v-model="showAveriaModal" centered :title="averiaForm.id ? 'Editar avería' : 'Registrar avería'" @ok.prevent="guardarAveria" :ok-disabled="guardandoAveria" ok-title="Guardar" cancel-title="Cancelar">
      <div class="maq-fields">
        <div class="maq-field">
          <label>Motivo</label>
          <v-select v-model="averiaForm.motivoSel" :options="opcionesMotivo" label="texto" :clearable="false" class="select-styled" @input="onMotivoElegido" />
        </div>
        <div class="maq-field" v-if="averiaForm.motivoSel && averiaForm.motivoSel.id == null">
          <label>Escribe el motivo</label>
          <b-form-input v-model="averiaForm.motivoLibre" placeholder="Describe la avería" class="maq-input" />
        </div>
        <div class="maq-field">
          <label>Fecha</label>
          <b-form-input type="date" v-model="averiaForm.fecha" class="maq-input" />
        </div>
        <div class="maq-field">
          <label>Precio (opcional)</label>
          <b-form-input type="number" step="any" v-model.number="averiaForm.precio" placeholder="€" class="maq-input" />
        </div>
        <div class="maq-field">
          <label>Nota</label>
          <b-form-input v-model="averiaForm.nota" placeholder="Opcional" class="maq-input" />
        </div>
      </div>
    </b-modal>

    <!-- ============ MODAL COPIAR MOTIVOS ============ -->
    <b-modal v-model="showCopiarModal" title="Copiar motivos de otra máquina" @ok.prevent="copiarMotivos" ok-title="Copiar" cancel-title="Cancelar">
      <div class="maq-fields">
        <div class="maq-field">
          <label>Copiar los motivos de</label>
          <v-select v-model="copiarOrigen" label="nombre" :options="otrasMaquinas" class="select-styled" />
        </div>
        <span class="maq-muted">Se añadirán a "{{ maquinaSel && maquinaSel.nombre }}" los motivos que no tenga ya.</span>
      </div>
    </b-modal>

    <!-- ============ MODAL CATEGORÍAS ============ -->
    <b-modal v-model="showCategoriasModal" title="Categorías de máquinas" ok-only ok-title="Cerrar">
      <div class="cat-manage">
        <div class="cat-manage__row" v-for="c in listCategorias" :key="c.id">
          <span>{{ c.nombre }} <small class="maq-muted">· {{ c.numMaquinas }} máquinas</small></span>
          <button class="icon-btn icon-btn--danger" @click="eliminarCategoria(c)"><i class="fa-solid fa-trash"></i></button>
        </div>
        <span class="maq-muted" v-if="listCategorias.length == 0">No hay categorías todavía.</span>
        <div class="motivo-add">
          <b-form-input v-model="nuevaCategoria" placeholder="Nueva categoría" class="maq-input" @keyup.enter="crearCategoria" />
          <button class="btn-alm btn-alm--primary btn-alm--xs" @click="crearCategoria"><i class="fa-solid fa-plus"></i></button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from '@axios'
import vSelect from 'vue-select'

export default {
  components: { vSelect },
  data() {
    return {
      listMaquinas: [],
      listCategorias: [],
      kpi: {},
      buscarMaquina: '',

      filtroCategoria: null,
      catStats: {},

      maquinaSel: null,
      motivos: [],
      averias: [],
      stats: {},

      showMaquinaModal: false,
      maquinaForm: { id: null, nombre: '', nota: '', refFabricante: '', refInterna: '', categoriaSel: null },

      showCategoriasModal: false,
      nuevaCategoria: '',

      nuevoMotivo: { texto: '', precio: null },

      showAveriaModal: false,
      guardandoAveria: false,
      averiaForm: { id: null, motivoSel: null, motivoLibre: '', fecha: '', precio: null, nota: '' },

      showCopiarModal: false,
      copiarOrigen: null,

      columnasMaquinas: [
        { key: 'refInterna', label: 'Ref. Interna', sortable: true },
        { key: 'nombre', label: 'Máquina', sortable: true },
        { key: 'categoria', label: 'Categoría', sortable: true },
        { key: 'numAverias', label: 'Averías', sortable: true },
        { key: 'gastoTotal', label: 'Gasto', sortable: true },
        { key: 'ultimaAveria', label: 'Última', sortable: true },
        { key: 'acciones', label: '', thStyle: { width: '90px' }, tdClass: 'text-nowrap' },
      ],
      columnasAverias: [
        { key: 'fecha', label: 'Fecha' },
        { key: 'motivo', label: 'Motivo' },
        { key: 'estado', label: 'Estado' },
        { key: 'precio', label: 'Precio' },
        { key: 'nota', label: 'Nota' },
        { key: 'usuario', label: 'Usuario' },
        { key: 'acciones', label: '', thStyle: { width: '90px' }, tdClass: 'text-nowrap' },
      ],
    }
  },
  computed: {
    opcionesMotivo() {
      return [...this.motivos, { id: null, texto: 'Otros (escribir)' }]
    },
    otrasMaquinas() {
      if (!this.maquinaSel) return this.listMaquinas
      return this.listMaquinas.filter(m => m.id != this.maquinaSel.id)
    },
    maquinasFiltradas() {
      let l = this.listMaquinas
      if (this.filtroCategoria) l = l.filter(m => m.idCategoria == this.filtroCategoria.id)
      if (this.buscarMaquina) {
        const b = this.buscarMaquina.toLowerCase()
        l = l.filter(m => String(m.id).includes(b) || (m.nombre && m.nombre.toLowerCase().includes(b))
          || (m.refFabricante && m.refFabricante.toLowerCase().includes(b))
          || (m.refInterna && m.refInterna.toLowerCase().includes(b)))
      }
      return l
    },
  },
  created() {
    axios.post('/uso', { seccion: 'maquinas' })
    this.loadCategorias()
    this.loadMaquinas()
  },
  methods: {
    loadKpi() {
      axios.get('/maquinas/kpi').then(r => { this.kpi = r.data })
    },
    loadCategorias() {
      axios.get('/maquinas/categorias').then(r => {
        this.listCategorias = r.data
        // Refresca la referencia del filtro con los contadores nuevos
        if (this.filtroCategoria) {
          this.filtroCategoria = this.listCategorias.find(c => c.id == this.filtroCategoria.id) || null
        }
      })
    },
    loadMaquinas(seleccionarId = null) {
      this.loadKpi()
      axios.get('/maquinas').then(r => {
        this.listMaquinas = r.data
        if (seleccionarId) {
          const m = this.listMaquinas.find(x => x.id == seleccionarId)
          if (m) this.seleccionar(m)
        } else if (this.maquinaSel) {
          this.maquinaSel = this.listMaquinas.find(x => x.id == this.maquinaSel.id) || null
        }
      })
    },

    // -------- Categorías --------
    seleccionarCategoria(cat) {
      this.filtroCategoria = cat
      this.maquinaSel = null
      if (cat) this.loadCatStats(cat.id)
    },
    loadCatStats(id) {
      axios.get('/maquinas/categorias/' + id + '/estadisticas').then(r => { this.catStats = r.data })
    },
    abrirCategorias() {
      this.nuevaCategoria = ''
      this.showCategoriasModal = true
    },
    crearCategoria() {
      const n = (this.nuevaCategoria || '').trim()
      if (!n) return
      axios.post('/maquinas/categorias', { nombre: n }).then(() => {
        this.nuevaCategoria = ''
        this.loadCategorias()
      }).catch(this.toastError)
    },
    eliminarCategoria(c) {
      this.$bvModal.msgBoxConfirm('¿Eliminar la categoría ' + c.nombre + '? Sus máquinas quedarán sin categoría.', { okTitle: 'Eliminar', cancelTitle: 'Cancelar', okVariant: 'danger' })
        .then(ok => {
          if (!ok) return
          axios.post('/maquinas/categorias/delete', { id: c.id }).then(() => {
            this.toastOk('Categoría eliminada')
            if (this.filtroCategoria && this.filtroCategoria.id == c.id) this.filtroCategoria = null
            this.loadCategorias()
            this.loadMaquinas()
          }).catch(this.toastError)
        })
    },

    // -------- Selección de máquina --------
    seleccionar(m) {
      this.maquinaSel = m
      this.loadMotivos()
      this.loadAverias()
      this.loadStats()
    },
    seleccionarPorId(id) {
      const m = this.listMaquinas.find(x => x.id == id)
      if (m) this.seleccionar(m)
    },
    cerrarDetalle() {
      this.maquinaSel = null
      if (this.filtroCategoria) this.loadCatStats(this.filtroCategoria.id)
    },
    loadMotivos() {
      axios.get('/maquinas/' + this.maquinaSel.id + '/motivos').then(r => { this.motivos = r.data })
    },
    loadAverias() {
      axios.get('/maquinas/' + this.maquinaSel.id + '/averias').then(r => { this.averias = r.data })
    },
    loadStats() {
      axios.get('/maquinas/' + this.maquinaSel.id + '/estadisticas').then(r => { this.stats = r.data })
    },

    // -------- Máquinas --------
    abrirMaquinaForm(m) {
      if (m) {
        this.maquinaForm = {
          id: m.id, nombre: m.nombre, nota: m.nota,
          refFabricante: m.refFabricante || '', refInterna: m.refInterna || '',
          categoriaSel: this.listCategorias.find(c => c.id == m.idCategoria) || null,
        }
      } else {
        this.maquinaForm = { id: null, nombre: '', nota: '', refFabricante: '', refInterna: '', categoriaSel: this.filtroCategoria || null }
      }
      this.showMaquinaModal = true
    },
    guardarMaquina() {
      const f = this.maquinaForm
      if (!f.nombre || !f.nombre.trim()) return this.toastError({ response: { data: { msg: 'El nombre es obligatorio' } } })
      const payload = { id: f.id, nombre: f.nombre, nota: f.nota, refFabricante: f.refFabricante, refInterna: f.refInterna, idCategoria: f.categoriaSel ? f.categoriaSel.id : null }
      const req = f.id ? axios.put('/maquinas', payload) : axios.post('/maquinas', payload)
      req.then(({ data }) => {
        this.showMaquinaModal = false
        this.toastOk(f.id ? 'Máquina actualizada' : 'Máquina creada')
        this.loadCategorias()
        this.loadMaquinas(f.id || (data && data.id))
      }).catch(this.toastError)
    },
    eliminarMaquina(m) {
      this.$bvModal.msgBoxConfirm('¿Eliminar la máquina ' + m.nombre + '? El historial de averías se conserva.', { okTitle: 'Eliminar', cancelTitle: 'Cancelar', okVariant: 'danger' })
        .then(ok => {
          if (!ok) return
          axios.post('/maquinas/delete', { id: m.id }).then(() => {
            this.toastOk('Máquina eliminada')
            this.maquinaSel = null
            this.loadCategorias()
            this.loadMaquinas()
            this.loadKpi()
          }).catch(this.toastError)
        })
    },

    // -------- Motivos --------
    crearMotivo() {
      const t = (this.nuevoMotivo.texto || '').trim()
      if (!t) return
      axios.post('/maquinas/motivos', { idMaquina: this.maquinaSel.id, texto: t, precio: this.nuevoMotivo.precio })
        .then(() => {
          this.nuevoMotivo = { texto: '', precio: null }
          this.loadMotivos()
        }).catch(this.toastError)
    },
    eliminarMotivo(mo) {
      axios.post('/maquinas/motivos/delete', { id: mo.id }).then(() => this.loadMotivos()).catch(this.toastError)
    },
    abrirCopiarMotivos() {
      this.copiarOrigen = null
      this.showCopiarModal = true
    },
    copiarMotivos() {
      if (!this.copiarOrigen) return this.toastError({ response: { data: { msg: 'Elige una máquina de origen' } } })
      axios.post('/maquinas/motivos/copiar', { idOrigen: this.copiarOrigen.id, idDestino: this.maquinaSel.id })
        .then(({ data }) => {
          this.showCopiarModal = false
          this.toastOk('Copiados ' + (data && data.copiados) + ' motivos')
          this.loadMotivos()
        }).catch(this.toastError)
    },

    // -------- Averías --------
    abrirAveriaForm(a = null) {
      if (a && a.id) {
        const mo = a.idMotivo ? this.motivos.find(m => m.id == a.idMotivo) : null
        const otros = this.opcionesMotivo[this.opcionesMotivo.length - 1]
        this.averiaForm = {
          id: a.id,
          motivoSel: mo || otros,
          motivoLibre: mo ? '' : (a.motivo || ''),
          fecha: a.fecha ? String(a.fecha).slice(0, 10) : new Date().toISOString().slice(0, 10),
          precio: a.precio != null ? Number(a.precio) : null,
          nota: a.nota || '',
        }
      } else {
        const hoy = new Date().toISOString().slice(0, 10)
        this.averiaForm = { id: null, motivoSel: null, motivoLibre: '', fecha: hoy, precio: null, nota: '' }
      }
      this.showAveriaModal = true
    },
    onMotivoElegido(mo) {
      if (!this.averiaForm.id && mo && mo.id != null && mo.precio != null) this.averiaForm.precio = Number(mo.precio)
    },
    guardarAveria() {
      const f = this.averiaForm
      if (!f.motivoSel) return this.toastError({ response: { data: { msg: 'Elige un motivo' } } })
      const esOtros = f.motivoSel.id == null
      if (esOtros && !f.motivoLibre.trim()) return this.toastError({ response: { data: { msg: 'Escribe el motivo' } } })
      this.guardandoAveria = true
      const payload = {
        idMaquina: this.maquinaSel.id,
        idMotivo: esOtros ? null : f.motivoSel.id,
        motivo: esOtros ? f.motivoLibre.trim() : f.motivoSel.texto,
        precio: f.precio,
        nota: f.nota,
        fecha: f.fecha,
      }
      const req = f.id
        ? axios.put('/maquinas/averias', { ...payload, id: f.id })
        : axios.post('/maquinas/averias', payload)
      req.then(() => {
        this.showAveriaModal = false
        this.toastOk(f.id ? 'Avería actualizada' : 'Avería registrada')
        this.loadAverias()
        this.loadStats()
        this.loadMaquinas()
      }).catch(this.toastError).finally(() => { this.guardandoAveria = false })
    },
    marcarReparada(a, reparada) {
      axios.put('/maquinas/averias/reparada', { id: a.id, reparada }).then(() => {
        this.toastOk(reparada ? 'Avería marcada como reparada' : 'Avería vuelve a pendiente')
        this.loadAverias()
      }).catch(this.toastError)
    },
    eliminarAveria(a) {
      this.$bvModal.msgBoxConfirm('¿Eliminar esta avería?', { okTitle: 'Eliminar', cancelTitle: 'Cancelar', okVariant: 'danger' })
        .then(ok => {
          if (!ok) return
          axios.post('/maquinas/averias/delete', { id: a.id }).then(() => {
            this.toastOk('Avería eliminada')
            this.loadAverias()
            this.loadStats()
            this.loadMaquinas()
          }).catch(this.toastError)
        })
    },

    // -------- Utilidades --------
    fmtMoney(v) {
      if (v === null || v === undefined || v === '') return '0 €'
      return parseFloat(v).toLocaleString('es-ES', { minimumFractionDigits: 0, maximumFractionDigits: 2 }) + ' €'
    },
    fechaCorta(f) {
      return f ? String(f).slice(0, 10) : ''
    },
    toastError(e) {
      const msg = (e.response && e.response.data && e.response.data.msg) || 'Algo ha ido mal'
      this.$bvToast.toast(msg, { title: 'Error', variant: 'danger', solid: true })
    },
    toastOk(msg) {
      this.$bvToast.toast(msg, { title: 'Máquinas', variant: 'success', solid: true })
    },
  },
}
</script>

<style lang="scss" scoped>
$primary: #3B82F6;
$primary-dark: #2563EB;
$success: #10B981;
$warning: #F59E0B;
$danger: #EF4444;
$info: #06B6D4;
$border: #E2E8F0;
$text: #1E293B;
$muted: #64748B;
$card-bg: #FFFFFF;
$radius: 12px;
$radius-sm: 8px;
$shadow: 0 1px 3px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.04);

.almacen-page { max-width: 1200px; margin: 0 auto; padding: 0 8px; font-family: 'Plus Jakarta Sans', sans-serif; color: $text; }

// Header
.alm-header { display: flex; justify-content: space-between; align-items: flex-end; gap: 16px; flex-wrap: wrap; margin-bottom: 20px; }
.header-eyebrow { display: block; font-family: 'JetBrains Mono', monospace; font-size: 11px; font-weight: 600; letter-spacing: 1.5px; text-transform: uppercase; color: $primary; margin-bottom: 2px; }
.header-title { font-size: 24px; font-weight: 700; color: $text; margin: 0; }
.header-actions { display: flex; gap: 10px; }

.maq-muted { color: $muted; font-size: 13px; }
.maq-pad { padding: 12px 16px; display: block; font-family: 'JetBrains Mono', monospace; font-size: 12px; }
.cell-mono { font-family: 'JetBrains Mono', monospace; font-size: 13px; }

// Botones
.btn-alm {
  display: inline-flex; align-items: center; gap: 8px; padding: 8px 18px; border: none; border-radius: $radius-sm;
  font-family: 'Plus Jakarta Sans', sans-serif; font-size: 13px; font-weight: 600; cursor: pointer; transition: all .2s ease; white-space: nowrap;
  i { font-size: 11px; }
  &--primary { background: $primary; color: #fff; &:hover { background: $primary-dark; } }
  &--soft { background: #F1F5F9; color: $muted; &:hover { background: #E2E8F0; } }
  &--danger-soft { background: rgba($danger, .08); color: $danger; &:hover { background: rgba($danger, .15); } }
  &--xs { padding: 6px 12px; font-size: 12px; }
}

// KPI
.kpi-strip { display: grid; grid-template-columns: repeat(4, 1fr); gap: 12px; margin-bottom: 18px; }
.kpi-card { background: $card-bg; border: 1px solid $border; border-radius: $radius-sm; padding: 16px 18px; display: flex; flex-direction: column; box-shadow: $shadow; }
.kpi-label { font-family: 'JetBrains Mono', monospace; font-size: 10px; font-weight: 600; letter-spacing: 1px; text-transform: uppercase; color: $muted; }
.kpi-value { font-family: 'JetBrains Mono', monospace; font-size: 22px; font-weight: 700; color: $text; font-feature-settings: "tnum"; margin: 4px 0 2px; }
.kpi-foot { font-family: 'JetBrains Mono', monospace; font-size: 10px; color: $muted; }

// Barra de categorías
.cat-bar { display: flex; flex-wrap: wrap; gap: 8px; margin-bottom: 18px; }
.cat-chip {
  display: inline-flex; align-items: center; gap: 6px; padding: 7px 14px; border: 1px solid $border; background: $card-bg;
  border-radius: 20px; font-size: 13px; font-weight: 600; color: $text; cursor: pointer; transition: all .15s ease;
  small { font-family: 'JetBrains Mono', monospace; font-size: 10px; color: $muted; background: #F1F5F9; padding: 1px 6px; border-radius: 10px; }
  &:hover { border-color: $primary; }
  &--active { background: $primary; color: #fff; border-color: $primary; small { background: rgba(#fff, .25); color: #fff; } }
  &--add { color: $muted; padding: 7px 12px; }
}
.cat-ico { color: $primary; margin-right: 4px; }

// Badge de categoría
.cat-badge { display: inline-block; font-family: 'JetBrains Mono', monospace; font-size: 11px; font-weight: 600; color: $primary; background: rgba($primary, .1); padding: 3px 10px; border-radius: 6px; }

.maq-empty { display: flex; flex-direction: column; align-items: center; gap: 10px; padding: 30px; color: #CBD5E1; text-align: center; font-size: 13px;
  i { font-size: 24px; opacity: .6; } }

// list-card + tabla
.list-card { background: $card-bg; border: 1px solid $border; border-radius: $radius; box-shadow: $shadow; overflow: hidden; margin-bottom: 20px; }
.list-card__header { display: flex; justify-content: space-between; align-items: center; gap: 14px; flex-wrap: wrap; padding: 14px 20px; border-bottom: 1px solid $border; }
.list-card__hint { font-family: 'JetBrains Mono', monospace; font-size: 11px; color: $muted; }
.search-box { position: relative; flex: 1; max-width: 320px;
  &__icon { position: absolute; left: 10px; top: 50%; transform: translateY(-50%); color: $muted; font-size: 12px; }
  &__input { width: 100%; padding: 7px 12px 7px 32px; border: 1px solid $border; border-radius: $radius-sm; font-size: 13px; color: $text; background: transparent;
    &::placeholder { color: #CBD5E1; } &:focus { outline: none; border-color: $primary; } }
}
// Los ::v-deep van bajo .almacen-page a proposito: en la raiz, postcss-rtl + scoped generan [dir][data-v-xxx]
// y ninguna propiedad direccional (padding, margin...) llega a aplicarse.
.almacen-page ::v-deep .table-head th { font-family: 'JetBrains Mono', monospace; font-size: 10px; font-weight: 600; letter-spacing: 1px; text-transform: uppercase; color: $muted; border-top: none; border-bottom: 1px solid $border; padding: 10px 16px; background: transparent; }
.almacen-page ::v-deep .table-row td { padding: 10px 16px; vertical-align: middle; border-color: lighten($border, 3%); font-size: 13px; }

// Estado de la avería (pendiente / reparada)
.estado-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  border-radius: 20px;
  border: 1px solid transparent;
  font-family: 'JetBrains Mono', monospace;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;

  &--pendiente {
    background: rgba($warning, 0.1);
    color: darken($warning, 12%);
    border-color: rgba($warning, 0.25);

    &:hover {
      background: rgba($success, 0.12);
      color: darken($success, 8%);
      border-color: rgba($success, 0.3);
    }
  }

  &--reparada {
    background: rgba($success, 0.1);
    color: darken($success, 8%);
    border-color: rgba($success, 0.25);

    &:hover { background: rgba($success, 0.18); }
  }

  &__fecha {
    font-weight: 400;
    opacity: 0.75;
  }
}

.cell-nombre { display: flex; flex-direction: column;
  &__name { font-weight: 600; }
  &__sub { font-size: 11px; color: $muted; } }

// Detalle / paneles
.maq-detalle { background: $card-bg; border: 1px solid $border; border-radius: $radius; box-shadow: $shadow; padding: 20px; margin-bottom: 20px; }
.maq-detalle__head { display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 18px; gap: 12px; flex-wrap: wrap;
  h3 { margin: 0; font-size: 18px; font-weight: 700; color: $text; } }
.maq-detalle__meta { display: flex; align-items: center; gap: 10px; margin-top: 4px; }
.maq-detalle__actions { display: flex; gap: 8px; }

.maq-stats { display: grid; grid-template-columns: repeat(3, 1fr); gap: 12px; margin-bottom: 20px; }
.stat-box { background: #F8FAFC; border: 1px solid $border; border-radius: $radius-sm; padding: 14px 16px; text-align: center;
  &__num { display: block; font-family: 'JetBrains Mono', monospace; font-size: 20px; font-weight: 700; color: $text; }
  &__lbl { display: block; font-family: 'JetBrains Mono', monospace; font-size: 10px; letter-spacing: .5px; text-transform: uppercase; color: $muted; margin-top: 4px; } }

.maq-cols { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; margin-bottom: 16px; }
@media (max-width: 800px) { .maq-cols { grid-template-columns: 1fr; } .maq-stats { grid-template-columns: 1fr; } .kpi-strip { grid-template-columns: repeat(2, 1fr); } }

.maq-panel { border: 1px solid $border; border-radius: $radius-sm; margin-bottom: 16px; overflow: hidden;
  &__head { display: flex; justify-content: space-between; align-items: center; padding: 12px 16px; border-bottom: 1px solid $border; font-weight: 700; font-size: 13px; color: $text; } }

.comun-list { padding: 4px 0; }
.comun-row { display: flex; align-items: center; gap: 10px; padding: 8px 16px;
  &--click { cursor: pointer; &:hover { background: #F8FAFC; } }
  &__txt { flex: 1; font-size: 13px; }
  &__veces { font-family: 'JetBrains Mono', monospace; font-weight: 700; color: $primary; font-size: 13px; }
  &__gasto { font-family: 'JetBrains Mono', monospace; font-size: 12px; color: $muted; min-width: 60px; text-align: right; } }

.motivo-chips { display: flex; flex-wrap: wrap; gap: 8px; padding: 14px 16px; }
.motivo-chip { display: inline-flex; align-items: center; gap: 6px; background: rgba($primary, .08); color: $primary; padding: 5px 10px; border-radius: 6px; font-family: 'JetBrains Mono', monospace; font-size: 12px; font-weight: 600;
  small { color: $muted; font-weight: 500; }
  &__del { cursor: pointer; opacity: .5; &:hover { opacity: 1; color: $danger; } } }
.motivo-add { display: flex; gap: 8px; padding: 0 16px 14px; }

.maq-input { border: 1px solid $border; border-radius: $radius-sm; padding: 8px 12px; font-size: 13px; color: $text;
  &::placeholder { color: #CBD5E1; } &:focus { outline: none; border-color: $primary; } }
.maq-input--sm { max-width: 100px; }

// vue-select
.select-styled {
  ::v-deep .vs__dropdown-toggle { min-height: 38px; border-radius: $radius-sm; border: 1px solid $border; background: #fff; padding: 2px 6px; }
  ::v-deep .vs__search { font-size: 13px; font-family: 'Plus Jakarta Sans', sans-serif; }
  ::v-deep .vs__selected { font-size: 13px; }
  &.vs--open ::v-deep .vs__dropdown-toggle { border-color: $primary; box-shadow: 0 0 0 3px rgba($primary, .1); }
}

.maq-acciones { display: flex; gap: 4px; }
.icon-btn { width: 30px; height: 30px; border-radius: 6px; border: none; background: transparent; cursor: pointer; color: $muted; flex-shrink: 0;
  &:hover { background: rgba($primary, .1); color: $primary; }
  &--danger { color: $danger; &:hover { background: rgba($danger, .1); color: $danger; } } }

.maq-fields { display: flex; flex-direction: column; gap: 14px; }
.maq-field { display: flex; flex-direction: column; gap: 6px;
  label { font-family: 'JetBrains Mono', monospace; font-size: 10px; font-weight: 600; letter-spacing: .5px; text-transform: uppercase; color: $muted; } }

// Gestión de categorías (modal)
.cat-manage { display: flex; flex-direction: column; gap: 10px;
  &__row { display: flex; justify-content: space-between; align-items: center; padding: 8px 12px; border: 1px solid $border; border-radius: $radius-sm; font-size: 14px; } }
</style>

<style lang="scss">
@import '../@core/scss/vue/libs/vue-select.scss';

// Desplegables de v-select dentro de modales: con muchas opciones el menu
// (max-height 350px por defecto) se salia del modal y el click fuera lo cerraba.
// Se limita la altura para que haga scroll dentro del propio modal.
.modal .select-styled .vs__dropdown-menu {
  max-height: 200px;
  overflow-y: auto;
}

// Fila clicable de la tabla de máquinas (sin scope: el tr lo renderiza b-table)
tr.maq-row {
  cursor: pointer;

  td { transition: background 0.12s ease; }

  &:hover td {
    background: rgba(#3B82F6, 0.07) !important;
  }
}

// Modo oscuro (sin scoped: .dark-layout está en body)
body.dark-layout .almacen-page { color: #d0d2d6; }

.dark-layout .almacen-page {
  .header-title,
  .kpi-value,
  .stat-box__num,
  .maq-detalle__head h3,
  .maq-panel__head { color: #e4e6eb; }
  .maq-muted, .kpi-label, .kpi-foot, .list-card__hint { color: #8e9099; }

  .kpi-card,
  .list-card,
  .maq-detalle { background: #1f1f1f; border-color: #2c2c2c; box-shadow: none; }
  .list-card__header { border-bottom-color: #2c2c2c; }

  .btn-alm--soft { background: #242424; color: #b4b7bd; &:hover { background: #2c2c2c; color: #e4e6eb; } }

  .cat-chip:not(.cat-chip--active) {
    background: #1f1f1f; border-color: #2c2c2c; color: #d0d2d6;
    small { background: #2c2c2c; color: #b4b7bd; }
    &:hover { border-color: #3B82F6; }
  }

  .search-box__input { background: #161616; border-color: #2c2c2c; color: #d0d2d6; &::placeholder { color: #6e7079; } &:focus { border-color: #3B82F6; } }

  .stat-box { background: #161616; border-color: #2c2c2c; }
  .maq-panel { border-color: #2c2c2c; }
  .maq-panel__head { border-bottom-color: #2c2c2c; }
  .comun-row--click:hover { background: #242424; }

  .maq-input { background: #161616; border-color: #2c2c2c; color: #d0d2d6; &::placeholder { color: #6e7079; } &:focus { border-color: #3B82F6; } }

  // Tablas al tono de la tarjeta (los estilos globales de Vuexy usan !important)
  .table { background: #1f1f1f !important; }
  .table thead th { background: #1f1f1f !important; color: #8e9099 !important; border-bottom-color: #2c2c2c !important; }
  .table tbody tr { background: #1f1f1f !important; }
  .table tbody tr td { border-top-color: #2c2c2c !important; }
  .table tbody tr:hover { background: #242424 !important; }
}

// Modales (se montan en body, fuera de .almacen-page)
.dark-layout .modal {
  .maq-fields .maq-input,
  .cat-manage .maq-input { background: #161616; border-color: #2c2c2c; color: #d0d2d6; &::placeholder { color: #6e7079; } &:focus { border-color: #3B82F6; } }
  .maq-fields .select-styled .vs__dropdown-toggle { background: #161616; border-color: #2c2c2c; }
  .maq-fields .select-styled .vs__selected,
  .maq-fields .select-styled .vs__search { color: #d0d2d6; }
  .cat-manage__row { border-color: #2c2c2c; color: #d0d2d6; }
}
</style>
